import { observable, action } from "mobx";
import { get } from "../services/ajax.service";

class GroupStore {
    @observable group_id = '245';
    @observable filter_groups = 'cust';
    @observable market_check_groups = {
        pre_cust: [],
        cust: []
    }
    @observable programs = {
        rx_tourism: true,
        international_rx: true,
        alternative_funding: true,
        precision_pgx: true,
        specialty_carve_out: true,
        pcm_savings: true
    }
    @action setInitialGroup = async (obj) => {
        if (localStorage.getItem("filter_groups")) {
            this.filter_groups = localStorage.getItem("filter_groups")
        }
        if (localStorage.getItem("group_id")) {
            this.group_id = parseInt(localStorage.getItem("group_id"))
            await this.getGroupPrograms(this.group_id)
            return;
        }
        if (obj.cust.length > 0 && this.filter_groups == "cust") {

            if (obj.cust.some(i => i.id === this.group_id)) return;
            return this.setGroup(obj.cust[0].id);
            // this.group_id = obj.cust[0].id;
        }
        else if (obj.precust.length > 0 && this.filter_groups == "precust") {
            if (obj.precust.some(i => i.id === this.group_id)) return;
            return this.setGroup(obj.precust[0].id)
            // this.group_id = obj.precust[0].id;
        }
        else if (!obj.precust.length > 0 && obj.cust.length > 0) {
            this.filter_groups = "cust";
            return this.setInitialGroup(obj);
        }
        else if (obj.precust.length > 0 && !obj.cust.length > 0) {
            this.filter_groups = "precust";
            return this.setInitialGroup(obj);
        }
        else {
            this.setGroup('245');
        }

    }
    @action set_market_check_groups = (obj) => {
        this.market_check_groups = obj;
    }
    @action locateGroupName = (obj) => {
        let tmp = "";
        if (this.filter_groups == "cust") {
            tmp = obj.cust.find(v => v.id == this.group_id);
        }
        else {
            tmp = obj.precust.find(v => v.id == this.group_id);
        }
        return tmp ? tmp.name : "";
    }

    @action setGroup = async (group_id) => {
        localStorage.setItem("group_id", group_id)
        this.group_id = group_id;
        this.getGroupPrograms(group_id);
    }
    @action setFilter = (filter) => {
        localStorage.setItem("filter_groups", filter)
        this.filter_groups = filter;
    }
    @action getGroupPrograms = async (id, reports = false) => {

        const programs = await get(`/api/v1/userentityactions/programs/${id}`);

        if (reports) {
            return programs.data
        }
        this.programs = programs.data;
    }
    @action getGroupProgramswithoutAuth = async (id, reports = false) => {

        const programs = await get(`/api/v1/userentityaction/programs/${id}`);

        if (reports) {
            return programs.data
        }
        this.programs = programs.data;
    }
    @action setInitialGroupWithNoAuth = async (obj) => {
        if (localStorage.getItem("filter_groups")) {
            this.filter_groups = localStorage.getItem("filter_groups")
        }
        if (localStorage.getItem("group_id")) {
            this.group_id = parseInt(localStorage.getItem("group_id"))
            await this.getGroupProgramswithoutAuth(this.group_id)
            return;
        }
        if (obj.cust.length > 0 && this.filter_groups == "cust") {

            if (obj.cust.some(i => i.id === this.group_id)) return;
            return this.setGroup(obj.cust[0].id);
            // this.group_id = obj.cust[0].id;
        }
        else if (obj.precust.length > 0 && this.filter_groups == "precust") {
            if (obj.precust.some(i => i.id === this.group_id)) return;
            return this.setGroup(obj.precust[0].id)
            // this.group_id = obj.precust[0].id;
        }
        else if (!obj.precust.length > 0 && obj.cust.length > 0) {
            this.filter_groups = "cust";
            return this.setInitialGroup(obj);
        }
        else if (obj.precust.length > 0 && !obj.cust.length > 0) {
            this.filter_groups = "precust";
            return this.setInitialGroup(obj);
        }
        else {
            this.setGroup('245');
        }

    }

}

export default GroupStore;
